import { SirmaLogo } from './SirmaLogo.js';

import styles from './BrandLogo.module.css';

/**
 * The brand marks: the lockup, the loading indicator and the mobile menu
 * button. The console is Sirma-branded throughout.
 *
 * Deliberately still. The Sirma artwork is a flat lockup, so animating it would
 * mean inventing motion for a logo that was not drawn for it.
 */

/** The lockup, at the three sizes the shell and the login card ask for. */
export function BrandLogo({
  size = 'default',
  className,
}: {
  size?: 'default' | 'sidebar' | 'big';
  className?: string | undefined;
}): JSX.Element {
  return (
    <div
      className={[styles.logo, size === 'default' ? '' : (styles[size] ?? ''), className]
        .filter(Boolean)
        .join(' ')}
    >
      {/* Inline rather than an <img>, so the wordmark follows the theme — see
          SirmaLogo.tsx. */}
      <SirmaLogo className={styles.image} />
    </div>
  );
}

/**
 * The loading indicator.
 *
 * A plain ring rather than the logo, because a spinning wordmark reads as a
 * glitch. The ring is in the accent colour, which keeps it part of the interface.
 */
export function Spinner(): JSX.Element {
  return <span className={styles.spinner} aria-hidden="true" />;
}

/** The mobile menu button: three bars that cross into an X. */
export function MenuToggle({ open }: { open: boolean }): JSX.Element {
  return (
    <span className={`${styles.burger} ${open ? styles.burgerOpen : ''}`}>
      <svg
        viewBox="0 0 100 72"
        fill="none"
        stroke="currentColor"
        strokeWidth={6}
        strokeLinecap="round"
        aria-hidden="true"
      >
        <line className={styles.barTop} x1="22" y1="22" x2="78" y2="22" />
        <line className={styles.barMid} x1="22" y1="36" x2="78" y2="36" />
        <line className={styles.barLow} x1="22" y1="50" x2="78" y2="50" />
      </svg>
    </span>
  );
}
